<div class="header-container justify-content-between">
  <div class="header-content"></div>
  <div class="me-2 float-end">
    <app-header-elements></app-header-elements>
  </div>
</div>
<div *ngIf="showProgressBar" class="progress-bar-container">
  <p-progressBar mode="indeterminate" [style]="{ height: '2px' }"></p-progressBar>
</div>
